import {config as yesNoOverdueColumn} from '../../common/YesNoOverdueColumn';

export const prop = 'hasCRAEQRSO';
export const id = 'eqrOnCraColumn';

export const config = (labels) =>
	yesNoOverdueColumn({
		fullId: id,
		label: labels.eqrSignoffOnCra,
		prop,
		width: 'minmax(var(--px-180), 2fr)',
		isOverdue: (item) => item[prop] === false && item.isEQRCRASODlyd === true
	});
